/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';

interface ImportCsvAttributeFieldAttributeListItemArgs {
  item: Record<string, any>;
  labelProperty: string;
  isObject: boolean;
  isRelationship: boolean;
}

export default class ImportCsvAttributeFieldAttributeListItem extends Component<ImportCsvAttributeFieldAttributeListItemArgs> {
  @service environment!: EnvironmentService;

  get attribute() {
    return this.args.item[this.args.labelProperty] ?? this.args.item;
  }
}
